var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import mainTheme from "@irati/ui/src/global/theme";
import { boldStyles, regularStyles } from "@irati/ui/src/Typography/Input/styles";
var getBgColor = function (state) {
    if (state.isSelected)
        return mainTheme.colors.primary2;
    else if (state.isFocused)
        return mainTheme.colors.utility.highlight;
    return mainTheme.colors.utility.white;
};
var selectStyles = {
    container: function (base) { return (__assign(__assign({}, base), { margin: mainTheme.spacing.one + " 0" })); },
    control: function (base, state) { return (__assign(__assign({}, base), { border: "1px solid " + (state.isFocused ? mainTheme.colors.primary1 : mainTheme.colors.utility.subdued), borderRadius: mainTheme.border.radius, boxShadow: state.isFocused ? mainTheme.shadows.focus : "none", minHeight: 48 })); },
    dropdownIndicator: function (base, state) { return (__assign(__assign({}, base), { transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none" })); },
    menu: function (base) { return (__assign(__assign({}, base), { margin: mainTheme.spacing.one + " 0", boxShadow: mainTheme.shadows.low })); },
    menuList: function (base) { return (__assign(__assign({}, base), { padding: 0, borderRadius: mainTheme.border.radius })); },
    multiValue: function (base) { return (__assign(__assign(__assign({}, base), { borderRadius: 18, backgroundColor: mainTheme.colors.utility.highlight, padding: 0, fontFamily: mainTheme.font.bold }), boldStyles)); },
    multiValueLabel: function (base) { return (__assign(__assign({}, base), { paddingLeft: 3 })); },
    multiValueRemove: function (base) { return (__assign(__assign({}, base), { ":hover": {
            backgroundColor: "transparent",
            cursor: "pointer"
        } })); },
    option: function (base, state) { return (__assign(__assign(__assign({}, base), { padding: mainTheme.spacing.two, backgroundColor: getBgColor(state), ":active": {
            backgroundColor: getBgColor(state)
        } }), regularStyles)); },
    valueContainer: function (base) { return (__assign(__assign({}, base), { padding: "0 " + mainTheme.spacing.two })); }
};
export default selectStyles;
